import angular from 'angular';

(function() {
    'use strict';
    angular.module('app.core').factory('ControlSet', ControlSetData);

    /* @ngInject */
    function ControlSetData() {
        ControlSet.prototype = {
            build: build
        };

        function ControlSet(controlSetData) {
            this.build(controlSetData);
        }

        return ControlSet;

        /////////////////////

        function build(controlSetData) {
            this.key = controlSetData.key || null;
            this.label = controlSetData.label || null;
            this.desc = controlSetData.desc || null;
            this.standard = controlSetData.standard || false;
            this.mode = controlSetData.mode || null;
            this.selected = controlSetData.selected || false;
            this.submode = controlSetData.submode || null;
        }
    }
})();
